import { GeneralSearchResult } from "../types";
import { baseServerUrl } from "./apiConsts";
import { simpleRequest } from "./apiHelpers";

export interface GeneralSearchParams {
    query: string,
};
export const generalSearch = ({ query }: GeneralSearchParams) => {
    return simpleRequest('get', `${baseServerUrl}/search/general/${query}`, {} as GeneralSearchResult);
};